<template>
  <section class="news-container">
    <el-tabs
      v-model="activeTab"
      @tab-click="handleTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-date-picker
            v-model="date"
            type="daterange"
            @change="filterData"/>
        </div>
        <div>
          <v-button
            class="gray-btn"
            @click="handleNewCode">New Code</v-button>
        </div>
      </div>

      <div class="transparent">
        <el-table
          :data="codeData"
          style="width: 100%"
          :header-row-class-name="headerClass"
          @row-click="handlerRowClick">
          <el-table-column label="Code">
            <template #default="{row}">
              <p>
                {{row.code}}
                <span
                  class="status"
                  :class="{
                    'green': row.status == 1,
                    'yellow': row.status == 2
                  }">{{row.status == 1? 'Active' : 'Inactive'}}</span>
              </p>
            </template>
          </el-table-column>

          <!--          <el-table-column label="Days">-->
          <!--            <template #default="{row}">-->
          <!--              {{getOptionName('lengthOptions',row.day_type)}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            label="Used"
            prop="used_times"></el-table-column>
          <el-table-column label="Period">
            <template #default="{row}">
              <div class="time">
                <span>{{row.start_time}} -</span>
                <span>{{row.end_time}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"
    />

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import {mapActions} from 'vuex'
import {getTrialList} from '@/api/trailCode'

export default {
  name: 'TrailCodeList',
  mixins: [MixinOptions],
  props:{
    headerClass:{
      type:Function,
      default:()=>{
        return 'headerClass'
      }
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        size:20,
        currentPage: 1,
        total: 10
      },
      activeTab: '1',
      tabList: [
        {
          name: '1',
          label: 'Current Coupons'
        },
        {
          name: '2',
          label: 'Upcoming'
        },
        {
          name: '3',
          label: 'Past'
        },
      ],
      codeData: [],
      date:''
    }
  },
  watch: {
    getActiveTab:{
      immediate: true,
      handler(val){
        if(val && val != this.activeTab){
          this.activeTab = val
          this.handleTab()
        }
      }
    }
  },
  mounted(){
    this.handleTab()
  },
  methods: {
    ...mapActions('trialCode', ['setStatus', 'setActiveTab', 'setCodeData']),
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getTrialList()
    },
    handleTab(){
      this.pageConfig.currentPage = 1
      this.setActiveTab(this.activeTab)
      this.network().getTrialList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getTrialList()
    },
    handlerRowClick(row) {
      this.setStatus('edit')
      this.setCodeData(row)
      this.$router.push({
        path: '/administration/trail-code/detail',
      })
    },
    handleNewCode() {
      this.setStatus('create')
      this.setCodeData(null)
      this.$router.push({
        path: '/administration/trail-code/detail',
      })
    },
    network() {
      return {
        getTrialList: async () => {
          const {data} = await getTrialList({
            list_type: this.activeTab,
            start_time: this.date[0],
            end_time: this.date[1],
          })
          this.codeData = data.data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .gray-btn{
    background: #FAFBFC;
    border: 1px solid rgba(27, 31, 35, 0.15);
    box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    border-radius: 6px;
    color: #24292E;
    font-size: 12px;
    font-weight: 600;
  }
  .content-container {
    position: relative;
    .el-table {
      margin-top: 15px;
      border:1px solid #E1E4E8;
      border-radius: 4px;
      ::v-deep .headerClass{
        background:#F6F8FA;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
    }

    .filter-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .filter-list {
        display: flex;
        width: 300px;
      }
    }

    .status{
      padding: 1px 8px;
      height: 20px;
      background: #FFFFFF;
      border-radius: 100px;
      font-size: 12px;
      font-weight: 600;
      margin-left: 10px;
      &.green{
        border: 1px solid #28A745;
        color: #22863A;
      }
      &.yellow{
        border: 1px solid #B08800;
        color: #735C0F;
      }
    }

    .time{
      display: flex;
      flex-direction: column;
    }
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
